import { KeyboardArrowUp } from '@mui/icons-material';
import { IconButton } from '@mui/material';

export interface HeaderCollapseToggleProps {
  collapsed: boolean;
  onToggle: () => void;
}

/**
 * The caret that hides and shows a page header with a tap — the quick
 * equivalent of scrolling it away and pulling it back (see
 * `useCollapseOnScroll`, whose `collapsed` and `toggle` feed this).
 *
 * Sized to sit at the start of a search input in place of the magnifier, which
 * is where SearchPage and the pages laid out like it put it on a phone.
 * @param props - Component props
 * @param props.collapsed - Whether the header is currently hidden
 * @param props.onToggle - Called on tap
 * @returns The toggle button
 */
export function HeaderCollapseToggle({
  collapsed,
  onToggle,
}: HeaderCollapseToggleProps) {
  return (
    <IconButton
      size="small"
      edge="start"
      onClick={onToggle}
      aria-label={collapsed ? 'Show header' : 'Hide header'}
      aria-expanded={!collapsed}
    >
      {/* One caret, turned over when the header is hidden. */}
      <KeyboardArrowUp
        fontSize="small"
        sx={{
          transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease',
          '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
          },
        }}
      />
    </IconButton>
  );
}
